import React, { useState } from 'react';
import axios from 'axios';
import { createFeedBackURL } from '../api/api';
import { Helmet } from 'react-helmet';

const ContactUs = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(createFeedBackURL, {
        name,
        email,
        phone,
        message,
      });

      if (response.status === 201) {
        setIsSubmitted(true);
        setError('');
        setName('');
        setEmail('');
        setPhone('');
        setMessage('');
      }
    } catch (err) {
      setIsSubmitted(false);
      setError('An error occurred. Please try again.');
      console.error('Feedback submission error:', err);
    }
  };

  return (
    <>
      <Helmet>
      <title>Contact Us – SomeOne4u</title>
  <meta name="description" content="Need support, have questions, or want to partner with us? Contact SomeOne4u for quick assistance and reliable responses." />
  <meta name="keywords" content="SomeOne4u contact, dating support, customer service, matchmaking help, feedback, partnership inquiries" />
  <meta name="author" content="SomeOne4u Team" />
  <meta name="application-name" content="SomeOne4u" />
  <link rel="canonical" href="https://someone4u.com/contactus" />
 
  {/* Open Graph */}
  <meta property="og:title" content="Contact Us – SomeOne4u" />
  <meta property="og:description" content="We're here to help! Contact SomeOne4u for support, questions, or business inquiries." />
  <meta property="og:url" content="https://someone4u.com/contactus" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="SomeOne4u" />
  <meta property="og:image" content="https://someone4u.com/image/splash.png" />
 
  {/* Twitter Card */}
  {/* <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="Contact Us – SomeOne4u" />
  <meta name="twitter:description" content="Reach out to the SomeOne4u team for any questions or support needs." />
  <meta name="twitter:image" content="https://someone4u.com/image/splash.png" /> */}
</Helmet>

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          padding: '20px',
        }}
        className="md:mb-0 mb-10"
      >
        <div
          style={{
            backgroundColor: '#fff',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            padding: '40px',
            maxWidth: '600px',
            width: '100%',
          }}
        >
          <h1 style={{ textAlign: 'center', marginBottom: '30px', color: '#333', fontSize: '48px', fontWeight: 'bold' }}>
            Contact Us
          </h1>

          <p style={{ textAlign: 'center', fontSize: '18px', color: '#777' }}>
            <strong>Last updated on April 21, 2025</strong>
          </p>

          <section style={{ marginTop: '30px', color: '#555', lineHeight: '1.6' }}>
            <h2 style={{ fontSize: '24px', marginBottom: '20px', color: '#444' }}>
              Reach out to us using the information below:
            </h2>

            <ul style={{ listStyleType: 'none', paddingLeft: '0' }}>
              <li style={{ marginBottom: '10px' }}>
                <strong>Merchant Legal Entity Name:</strong>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Registered Address:</strong>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Operational Address:</strong>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Mobile No:</strong>{' '}
                <a href="tel:" style={{ textDecoration: 'none', color: '#555' }}>
                  
                </a>
              </li>
              <li style={{ marginBottom: '10px' }}>
                <strong>Telephone No:</strong>{' '}
                <a href="tel:" style={{ textDecoration: 'none', color: '#555' }}>
                  
                </a>
              </li>
              <li>
                <strong>Email ID:</strong>{' '}
                {/* <a href="mailto:support@someone4u.in" style={{ textDecoration: 'none', color: '#555' }}>
                  support@someone4u.in / hello@someone4u.in
                </a> */}
              </li>
            </ul>
          </section>

          <div className="contact-form" style={{ marginTop: '40px' }}>
            <h2
              style={{
                fontSize: '24px',
                marginBottom: '20px',
                color: '#333',
                textAlign: 'center',
              }}
            >
              Got a question or feedback?
            </h2>

            <form onSubmit={handleSubmit}>
              <label htmlFor="name"><b>Name:</b></label>
              <input
                type="text"
                id="name"
                name="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Your Name"
                style={{
                  width: '100%',
                  padding: '10px',
                  marginBottom: '15px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                }}
                required
              />

              <label htmlFor="email"><b>Email:</b></label>
              <input
                type="email"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Your Email"
                style={{
                  width: '100%',
                  padding: '10px',
                  marginBottom: '15px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                }}
                required
              />

              <label htmlFor="phone"><b>Phone:</b></label>
              <input
                type="tel"
                id="phone"
                name="phone"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                placeholder="Your Phone Number"
                style={{
                  width: '100%',
                  padding: '10px',
                  marginBottom: '15px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                }}
              />

              <label htmlFor="message"><b>Your Message:</b></label>
              <textarea
                id="message"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Your Message"
                style={{
                  width: '100%',
                  padding: '10px',
                  marginBottom: '15px',
                  border: '1px solid #ccc',
                  borderRadius: '5px',
                  minHeight: '100px',
                }}
                required
              />

              <input
                type="submit"
                value="SUBMIT"
                style={{
                  width: '100%',
                  padding: '10px',
                  backgroundColor: '#e91e63',
                  color: '#fff',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '16px',
                }}
              />
            </form>

            {isSubmitted && (
              <p style={{ color: 'green', marginTop: '15px', textAlign: 'center' }}>
                Thank you! Your message has been received.
              </p>
            )}
            {error && (
              <p style={{ color: 'red', marginTop: '15px', textAlign: 'center' }}>
                {error}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactUs;
